module.exports = __webpack_public_path__ + "static/img/3.1b31a23.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/eng/3.png
// module id = hB62
// module chunks = 0